export default __webpack_public_path__ + "static/media/Universite De LOntario Francais.2a9bcedb.jpg";